export default function LoadableStore({ options, store }) {
    if (options.loadable) {
        const loadAction = options.loadable.action;
        const loadFunction = store[loadAction];
        const loadableFromPage = options.loadable.fromPage;
        store.loadingPromise = null;
        // Overwrite the load action with a wrapper that knows how to load from page
        // and de-duplicate multiple load requests
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        store[loadAction] = function (...args) {
            // Skip if already loaded
            if (store.loadingPromise) {
                return store.loadingPromise;
            }
            // Load from page data if available
            if (loadableFromPage && window.serverState) {
                const serverData = window.serverState.retrieveState(loadableFromPage.key);
                if (serverData) {
                    store[loadableFromPage.onLoad](serverData);
                    store.loadingPromise = Promise.resolve(serverData);
                    return store.loadingPromise;
                }
            }
            // Fallback to use the store's load routine
            store.loadingPromise = loadFunction(...args);
            return store.loadingPromise;
        };
        // Wire a reload action directly to the original load function
        if (options.loadable.reloadable) {
            store["reload"] = () => {
                store.loadingPromise = null;
                store[loadAction]();
            };
        }
        // Wire a load on init
        if (options.loadable.autoload) {
            store[loadAction]();
        }
    }
}
